// import React, { useEffect, useRef, useState } from "react";
// import capital_infra_logo from "../../../assets/images/ipodetails/capital_infra_logo 1.svg"
// import { IpoDetails } from "./IpoDetails";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { getIpoDetail, subscriptionDetails } from "../../../api/IposApi";
// import { Images, setIpoDetail } from "../../../utils/npm";
// import { ReviewDetails } from "./ReviewDetails";
// import { SubscriptionDetails } from "./SubscriptionDetails";
// import { NewsDetailsData } from "./NewsDetailsData";
// import { GmpDetails } from "./GmpDetails";
// import { AllotnmentDetails } from "./AllotnmentDetails";
// import { BasicAllotnmentDetails } from "./BasicAllotnmentDetails";
// import Loader from "../../../components/Loader";
// import { formatDate, formatIndianPrice, SEOLINK, SEOTITLE, TABKEY, useIpoDetailsPageRedirection } from "../../../components/CommonFunction";
// import Select from "react-dropdown-select";
// import FilterListingType from "../../../components/FilterListingType";
// import { Footer } from "../../../routes/MyRoutes";
// import Labels from "../../../components/Labels";
// import BreadCrumb from "../../../components/BreadCrumb";
// import ApplyButtons from "../../../components/ApplyButtons";
// const { ipoDefault } = Images
// const {
//   logo,
//   facebook,
//   Instagram,
//   Telegram,
//   Youtube,
//   twitter,
//   Whatsapp,
//   playStore,
//   appStore
// } = Images

// const IPODetailsTab = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { t } = useLocation();

//   const [metaData, setMetaData] = useState({
//     title: "",
//     description: "",
//     keyword: "IPO Calendar 2025, Upcoming IPOs, Mainboard IPO Calendar, SME IPO Calendar, New IPOs 2025, Apply for IPO, IPO Dates"
//   });

//   const { ipoDetailData, ipoDetailLoading } = useSelector(state => state.ipoDetail);
//   const { ipoCategory } = useSelector(state => state.ipoData)
//   const IpoDetailsPageRedirection = useIpoDetailsPageRedirection(); // Call the hook inside a component
//   const { id, name, tabname } = useParams()

//   const [activeTab, setActiveTab] = useState(TABKEY?.DETAILS_TAB);
//   const [isDocsDropdownOpen, setIsDocsDropdownOpen] = useState(false);
//   const [is_loading, setIsLoading] = useState(false);
//   const [is_allotnment, setIs_allotnment] = useState(false);

//   const [tabDetails, setTabDetails] = useState([
//     {
//       id: 1,
//       key: TABKEY?.DETAILS_TAB,
//       name: 'IPO Details',
//       content: <IpoDetails location={location} />
//     },
//     {
//       id: 2,
//       key: TABKEY?.DOC_TAB,
//       name: 'Docs',
//       content: <FilterListingType location={location} />
//     },
//     // {
//     //   id: 3,
//     //   key: TABKEY?.REVIEW_TAB,
//     //   name: 'Review',
//     //   content: <ReviewDetails location={location} />
//     // },
//     {
//       id: 4,
//       key: TABKEY?.SUBSCRIPTION_TAB,
//       name: 'Subscription',
//       content: <SubscriptionDetails location={location} id={id} is_loading={is_loading} setIsLoading={setIsLoading} />
//     },
//     {
//       id: 5,
//       key: TABKEY?.NEWS_TAB,
//       name: 'News',
//       content: <NewsDetailsData location={location} />
//     },
//     {
//       id: 6,
//       key: TABKEY?.GMP_TAB,
//       name: 'GMP',
//       content: <GmpDetails />
//     },
//     {
//       id: 7,
//       key: TABKEY?.ALLOTNMENT_TAB,
//       name: 'Allotment',
//       content: <AllotnmentDetails activeTab={activeTab} />
//     }
//     // {
//     //   id: 8,
//     //   key: TABKEY?.BASIC_ALLOTNMENT_TAB,
//     //   name: 'Basic Allotment',
//     //   content: <BasicAllotnmentDetails />
//     // },
//   ])

//   const handleTabClick = (key) => {
//     const pathSegments = location.pathname.split('/');
//     if (key == TABKEY?.ALLOTNMENT_TAB) {
//       setIs_allotnment(true)
//     } else {
//       setIs_allotnment(true)
//     }
//     pathSegments[pathSegments.length - 1] = key;
//     navigate(`${pathSegments.join('/')}`, { replace: true });

//     setActiveTab(key);
//     setIsDocsDropdownOpen(false);
//   };

//   const isFirstRun = useRef(true);
//   useEffect(() => {

//     // if (isFirstRun.current) {
//     //   isFirstRun.current = false;
//     //   return; // Prevents first duplicate call
//     // }

//     // const searchParams = new URLSearchParams(location.search);
//     // const tabFromUrl = searchParams?.get('ipo-watch'); // Get tab from URL

//     // if (!tabFromUrl) {
//     //   const searchParams = new URLSearchParams(location.search);
//     //   searchParams.set('ipo-watch', location?.state?.tabkey || 'ipo_details' + '-ipo');
//     //   navigate(`${location.pathname}?${searchParams.toString()}`, { replace: true });
//     // }
//     // const extractedTab = tabFromUrl?.split('-')[0];

//     if (tabname) {
//       // setActiveTab(
//       //   location?.state?.tabkey || tabname === TABKEY?.DOC_TAB || location?.state?.tabkey || tabname === TABKEY?.REVIEW_TAB
//       //     ? TABKEY?.DETAILS_TAB || tabname === TABKEY?.ALLOTNMENT_TAB
//       //     : location?.state?.tabkey || tabname
//       // );
//       setActiveTab(tabname);
//     } else {
//       setActiveTab(TABKEY?.DETAILS_TAB)
//       const pathSegments = location?.pathname?.split('/');
//       pathSegments[pathSegments?.length] = TABKEY?.DETAILS_TAB;
//       navigate(`${pathSegments.join('/')}`, { replace: true });
//     }
//   }, [tabname])

//   // ------------------------------ Calling Api ------------------------------

//   const companyName = ipoDetailData?.company_name?.split(" ").slice(0, 2).join(" ") + " IPO";
//   const dispatch = useDispatch();

//   const getDetail = async () => {
//     try {
//       // dispatch(startMasterLoding(true));
//       setIsLoading(true)
//       if (location?.state?.data?.company_name) {
//         dispatch(setIpoDetail(location?.state?.data))
//       } else {
//         const response = await getIpoDetail(id?.toUpperCase())
//         if (response && response.meta && response.meta.status_code === 200) {
//           dispatch(setIpoDetail(response.data))
//         } else {
//           dispatch(setIpoDetail(response.data))
//         }
//       }
//       setIsLoading(false)
//     } catch (error) {
//     } finally {
//       setIsLoading(false)
//     }
//   }

//   useEffect(() => {
//     // if (isFirstRun.current) {
//     //   isFirstRun.current = false;
//     //   return;
//     // }
//     getDetail();
//   }, [id])

//   useEffect(() => {
//     const getMetaByTab = () => {
//       switch (activeTab) {
//         case TABKEY?.DETAILS_TAB:
//           return {
//             title: `${companyName} : Price, Date, IPO GMP, Details`,
//             description: `${companyName}: Grey Market Premium at ₹${`${ipoDetailData?.gmp != null ? ipoDetailData?.gmp : ''}`}. Price band ${ipoDetailData?.price_range}. Allotment on ${formatDate(ipoDetailData?.allotment_date || '-')}. Track live subscription status (QIB/NII/Retail). Should you apply? Expert review inside.`,
//             keyword: "IPO Details 2025, Aten Papers IPO GMP , IPO grey market premium , IPO allotment date , how to check allotment status , IPO price band , lot size , IPO subscription status , QIB NII Retail demand"
//           };
//         case TABKEY?.DOC_TAB:
//           return {
//             title: "IPO Documents 2025 | Red Herring Prospectus, DRHP, Company Info",
//             description: "Access official IPO documents including Red Herring Prospectus, DRHPs, and detailed company filings for 2025.",
//             keyword: "IPO Documents 2025, RHP, DRHP, IPO Filing, Company Details"
//           };
//         case TABKEY?.SUBSCRIPTION_TAB:
//           return {
//             title: `${companyName} Subscription Status Live: QIB/NII/Retail Demand`,
//             description: `Track live ${companyName} subscription status with QIB, NII, and Retail demand updates. Check oversubscription trends in real-time.`,
//             keyword: "IPO subscription, live IPO subscription, IPO demand, QIB NII Retail, oversubscribed IPO"
//           };
//         case TABKEY?.NEWS_TAB:
//           return {
//             title: `${companyName} Latest News & Updates`,
//             description: `Stay updated with ${companyName} news, including subscription trends, GMP updates, and expert analysis.`,
//             keyword: "IPO news, IPO updates, Aten Papers IPO latest news, IPO trends"
//           };
//         case TABKEY?.GMP_TAB:
//           return {
//             title: `${companyName} GMP Today: Grey Market Premium & Trends`,
//             description: `Check today’s ${companyName} Grey Market Premium (GMP) with historical trends. Predict listing gains with unofficial IPO pricing.`,
//             keyword: "IPO GMP, grey market premium, IPO premium, upcoming IPO GMP, IPO grey market"
//           };
//         case TABKEY?.ALLOTNMENT_TAB:
//           return {
//             title: `${companyName} Allotment Status: Fast Check Allotment Here`,
//             description: `${companyName} allotment status is out! Check your allotment online via BSE/NSE links and next steps after allotment.`,
//             keyword: "IPO allotment, IPO allotment status, how to check IPO allotment, BSE IPO allotment"
//           };
//         default:
//           return {
//             title: `${companyName} Allotment Status: How to Check Online`,
//             description: `${companyName} allotment status is out! Check your allotment online via BSE/NSE links and next steps after allotment.`,
//             keyword: "IPO allotment, IPO allotment status, how to check IPO allotment, BSE IPO allotment"
//           };
//       }
//     };
//     setMetaData(getMetaByTab());
//   }, [activeTab, location, ipoDetailData, companyName]);

//   const linkRef = useRef(null);

//   // const handleSelectChange = (e) => {
//   //   const selectedLink = e.target.value;
//   //   if (selectedLink && linkRef.current) {
//   //     linkRef.current.href = selectedLink;
//   //     // Optional: set target and rel dynamically if needed
//   //     linkRef.current.target = "_blank";
//   //     linkRef.current.rel = "noopener noreferrer";

//   //     // Trigger the click on hidden anchor to open the link
//   //     linkRef.current.click();
//   //   }
//   // };

//   const handleSelectChange = (e) => {
//     const selectedLink = e.target.value;
//     if (selectedLink) {
//       window.open(selectedLink, "_blank", "noopener,noreferrer");
//     }
//   };

//   return (
//     <>
//       <SEOTITLE title={metaData?.title} description={metaData?.description} keyword={metaData?.keyword} />

//       <div className="container">
//         <BreadCrumb title={'IPO Details'} header={'IPO Details'} subHeaderOnlyView={'IPO Details'} />
//       </div>

//       {/* // is_loading ? (<>
//         //   <div className="flex justify-center">
//         //     <Loader />
//         //   </div>
//         // </>) : (<> */}
//       {/* <div className="details_ipo_content"> */}

//       <div className="details_ipo common_heading_h2   ">
//         IPO Details
//       </div>
//       {/* </div> */}
//       <div className="container ">


//         <div className="border rounded-xl ">

//           {is_loading ? (<>
//             <div className="flex justify-center items-center custom-min-height">
//               <Loader />
//             </div>
//           </>) : (<>
//             <div className="details_header">

//               <div className="flex justify-end pt-5 pe-5">
//                 {/* <div className='max-w-40 ms-auto pb-3 pt-2 md:pt-0'> */}
//                 {/* <ApplyButtons data={ipoDetailData} ipoCategory={ipoDetailData?.ipo_status?.status} classList={"broker-actions"} type="inner" /> */}
//                 {/* </div> */}


//                 <Labels
//                   data={ipoDetailData}
//                   classList='badge-container  justify-end items-end flex-column'
//                 />
//                 {/* <div className='max-w-40 ms-auto pb-3 pt-2 md:pt-0'> */}

//                 {/* </div> */}
//               </div>

//               <div className="detials_header detials_header_2 px-2  lg:!pb-8 gap-5 justify-between flex-wrap">
//                 <div className="flex items-center gap-5 w-full lg:w-[72%] flex-wrap">
//                   <div className="w-full md:w-[28%] flex flex-col md:flex-row md:flex-nowrap">
//                     <img
//                       src={ipoDetailData?.ipo_image}
//                       alt="IPO Image"
//                       className=" rounded-lg shadow-md detials_header_img max-w-[200px] mb-5 md:mb-0"
//                     />
//                     <h2 className="ipoDetailDatacompany_name !ps-0">{ipoDetailData?.company_name} IPO</h2>
//                   </div>

//                   <div className="w-full md:w-[68%] flex justify-between items-center flex-wrap">
//                     <div>
//                       <div className="common_heading_h2 common_heading_h2_details flex-grow ipoDetailDatacompany_name_desktop">
//                         <h2>{ipoDetailData?.company_name} IPO</h2>
//                         <div>
//                         </div>
//                       </div>
//                       <div className="flex flex-wrap gap-3  xl:gap-x-5 ipo_detail_header_list">
//                         <div className="w-full md:w-[45%] flex  gap-1">
//                           <h5 className="text-capitalize font-semibold ipo_sub_head min-w-max">IPO Date :</h5>
//                           <label style={{ color: "#7B7B7B" }}>{`${formatDate(ipoDetailData?.start_date)} to ${formatDate(ipoDetailData?.end_date)}`}</label>
//                         </div>
//                         <div className="w-full md:w-[45%] flex  gap-2">
//                           <h5 className="text-capitalize font-semibold ipo_sub_head min-w-max">Issue Price :</h5>
//                           <label style={{ color: "#7B7B7B" }}>{`${ipoDetailData?.price_range}`}</label>
//                         </div>
//                         <div className="w-full md:w-[45%] flex  gap-2">
//                           <h5 className="text-capitalize font-semibold ipo_sub_head min-w-max">Allotment Date :</h5>
//                           <label style={{ color: "#7B7B7B" }}>{`${ipoDetailData?.allotment_date != null ? formatDate(ipoDetailData?.allotment_date) : ''}`}</label>
//                         </div>
//                         <div className="w-full md:w-[45%] flex  gap-2">
//                           <h5 className="text-capitalize font-semibold ipo_sub_head min-w-max">List Date :</h5>
//                           <label style={{ color: "#7B7B7B" }}>{`${ipoDetailData?.listing_date != null ? formatDate(ipoDetailData?.listing_date) : '' || '-'}`}</label>
//                         </div>
//                         <div className="w-full md:w-[45%] flex  gap-2">
//                           <h5 className="text-capitalize font-bold ipo_sub_head min-w-max">GMP :</h5>
//                           <label style={{ color: "#27ae60", fontWeight: 600 }}> {ipoDetailData.gmp == null
//                             ? '-'
//                             : `₹${ipoDetailData.gmp} (${ipoDetailData?.ipo_max_value !== 0 && ((ipoDetailData?.gmp / ipoDetailData?.ipo_max_value) * 100)?.toFixed(2) + '%'})`}</label>
//                         </div>
//                         <div className="w-full md:w-[45%] flex  gap-2">
//                           <h5 className="text-capitalize font-semibold ipo_sub_head min-w-max">List Price :</h5>
//                           <label style={{ color: "#7B7B7B" }}>{`${ipoDetailData?.listed_price != null ? formatIndianPrice(ipoDetailData?.listed_price) : '' || '-'}`}</label>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className=" w-full lg:w-[25%]  flex flex-wrap lg:flex-col lg:justify-between lg:items-end ">
//                   <div></div>
//                   <ApplyButtons data={ipoDetailData} ipoCategory={ipoCategory} classList={"broker-actions max-w-[200px] min-w-[200px] !mt-0 me-5 lg:me-0 mb-5 lg:mb-0"} type="inner" />
//                   <ul className="social_icons flex flex-wrap gap-4 justify-end pb-2 md:pb-0 pe-2 md:pe-0 ">
//                     <li className="social_icon_item_second">
//                       <a href="https://www.facebook.com/share/1P2hsboiYc/" target="_blank" rel="noopener noreferrer">
//                         <SEOLINK title="Facebook Link" description="Facebook Link" image={appStore} url="https://www.facebook.com/share/1P2hsboiYc/" />
//                         <img src={facebook} alt="Facebook" width={40} height={40} />
//                       </a>
//                     </li>
//                     <li className="social_icon_item_second">
//                       <a href="https://x.com/ipo_trend_" target="_blank" rel="noopener noreferrer">
//                         <img src={twitter} alt="Twitter" width={40} height={40} />
//                       </a>
//                     </li>
//                     <li className="social_icon_item_second">
//                       <a href="https://t.me/ipotrend" target="_blank" rel="noopener noreferrer">
//                         <img src={Telegram} alt="Telegram" width={40} height={40} />
//                       </a>
//                     </li>
//                     <li className="social_icon_item_second">
//                       <a href="https://www.whatsapp.com/channel/0029Vb1Pg6g6xCSPrDjbw231" target="_blank" rel="noopener noreferrer">
//                         <img src={Whatsapp} alt="Whatsapp" width={40} height={40} />
//                       </a>
//                     </li>
//                     <li className="social_icon_item_second">
//                       <a href="https://www.instagram.com/ipo_trend_/" target="_blank" rel="noopener noreferrer">
//                         <img src={Instagram} alt="Instagram" width={40} height={40} />
//                       </a>
//                     </li>
//                   </ul>
//                 </div>
//               </div>
//             </div>

//             <div className="tabs-wrapper newTabIpoDetail ">
//               <div className="tabs-container">
//                 <div className="tabsss">
//                   <div className="tab-menu overflow-x-auto ps-3">
//                     {tabDetails?.length > 0 && tabDetails?.map((item) => (
//                       <>
//                         {
//                           item.key === TABKEY?.DOC_TAB ? (<>
//                             {/* <select
//                               className={`tab-menu-link custom-select p-0 ${activeTab === item?.key ? "is-active" : ""}`}
//                               value={'Docs'}
//                               onChange={(e) => {
//                                 const selectedLink = e.target.value;
//                                 if (selectedLink) {
//                                   window.open(selectedLink, "_blank", "noopener,noreferrer");
//                                 }
//                               }}
//                             >
//                               <option value="">{item.name}</option>
//                               {ipoDetailData?.ipo_doc_link?.map((item, index) =>
//                                 item?.link ? (
//                                   <option key={index} value={item.link}>
//                                     {item.lable}
//                                   </option>
//                                 ) : null
//                               )}
//                             </select> */}
//                             {/* <select
//                               className={`tab-menu-link custom-select p-0 ${activeTab === item?.key ? "is-active" : ""}`}
//                               defaultValue=""
//                               onChange={handleSelectChange}
//                             >
//                               <option value="">{item.name}</option>
//                               {ipoDetailData?.ipo_doc_link?.map((docItem, index) =>
//                                 docItem?.link ? (
//                                   <option key={index} value={docItem?.link}>
//                                     {docItem.lable}
//                                   </option>
//                                 ) : null
//                               )}
//                             </select>

//                             <a
//                               ref={linkRef}
//                               style={{
//                                 position: "absolute",
//                                 left: "-9999px",
//                                 width: "1px",
//                                 height: "1px",
//                                 overflow: "hidden",
//                               }}
//                               href="/"
//                               target="_blank"
//                               rel="noopener noreferrer"
//                             >
//                               Hidden Link
//                             </a> */}
//                             <select
//                               className={`tab-menu-link custom-select p-0 ${activeTab === item?.key ? "is-active" : ""}`}
//                               defaultValue=""
//                               onChange={handleSelectChange}
//                             >
//                               <option value="">{item.name}</option>
//                               {ipoDetailData?.ipo_doc_link?.map((docItem, index) =>
//                                 docItem?.link ? (
//                                   <option key={index} value={docItem?.link}>
//                                     {docItem.lable}
//                                   </option>
//                                 ) : null
//                               )}
//                             </select>
//                             <a
//                               ref={linkRef}
//                               style={{
//                                 position: "absolute",
//                                 left: "-9999px",
//                                 width: "1px",
//                                 height: "1px",
//                                 overflow: "hidden",
//                               }}
//                               href="/"
//                               target="_blank"
//                               rel="noopener noreferrer"
//                             >
//                               Hidden Link
//                             </a>
//                           </>) : (<>
//                             <button
//                               key={item.key}
//                               className={`tab-menu-link ${activeTab === item.key ? "is-active" : ""}`}
//                               data-content={item.key}
//                               onClick={() => handleTabClick(item.key)}
//                             >
//                               <span className="text-nowrap" data-title={item?.name}>{item?.name}</span>
//                             </button>
//                           </>)
//                         }
//                       </>))}
//                   </div>

//                   {/*                   
//                   <div className="tab-bar">
//                     {tabDetails?.map((item) => (
//                       <div
//                         key={item.key}
//                         className={`tab-bar-content ${activeTab === item.key ? "is-active" : ""}`}
//                         id={item.key}
//                       >
//                         {item?.content}
//                       </div>
//                     ))}
//                   </div> */}

//                   {/* <div className="tab-menu overflow-x-auto">
//                     {tabDetails?.map((item) => (<>
//                         <button
//                           className={`tab-menu-link border ${activeTab === item.key ? "is-active" : ""
//                             }`}
//                           onClick={() => handleTabClick(item.key)}
//                         >
//                           <span>{item.name}</span>
//                           {item.key === TABKEY?.DOC_TAB && <span> ▼</span>}
//                         </button>

//                         {item.key === TABKEY?.DOC_TAB && isDocsDropdownOpen && (
//                           // <div className="absolute left-0 mt-1 w-48 bg-white border rounded shadow-lg z-20">
//                           <ul>
//                             {options.map((option) => (
//                               <li
//                                 key={option.id}
//                                 className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
//                                 onClick={() => {
//                                   console.log("Selected:", option);
//                                   setIsDocsDropdownOpen(false); // Close dropdown on select
//                                 }}
//                               >
//                                 {option.label}
//                               </li>
//                             ))}
//                           </ul>
//                           // </div>
//                         )}
//                       </>  ))}
//                   </div> */}

//                   {/* Tab Content */}
//                   <div className="tab-bar mt-4">
//                     {tabDetails?.map((item) => (
//                       <div
//                         key={item.key}
//                         className={`tab-bar-content ${activeTab === item.key ? "is-active" : "hidden"}`}
//                       >
//                         {item.content}
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>

//           </>)}
//         </div>
//       </div >
//       {/* // </>) */}
//       <Footer />
//     </>
//   );

// };

// export default IPODetailsTab;

import React, { lazy, useEffect, useRef, useState } from 'react'
import capital_infra_logo from '../../../assets/images/ipodetails/capital_infra_logo 1.svg'
// const Header = Loadable(lazy(() => import("./IpoDetails")));
import { IpoDetails } from './IpoDetails'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getIpoDetail, subscriptionDetails } from '../../../api/IposApi'
import { Images, setIpoDetail } from '../../../utils/npm'
import { ReviewDetails } from './ReviewDetails'
import { SubscriptionDetails } from './SubscriptionDetails'
import { NewsDetailsData } from './NewsDetailsData'
import { GmpDetails } from './GmpDetails'
import { AllotnmentDetails } from './AllotnmentDetails'
import { BasicAllotnmentDetails } from './BasicAllotnmentDetails'
import Loader from '../../../components/Loader'
import {
  formatDate,
  SEOLINK,
  SEOTITLE,
  TABKEY,
  useIpoDetailsPageRedirection
} from '../../../components/CommonFunction'
import Select from 'react-dropdown-select'
import FilterListingType from '../../../components/FilterListingType'
import { Footer, Loadable } from '../../../routes/MyRoutes'
import Labels from '../../../components/Labels'
import BreadCrumb from '../../../components/BreadCrumb'
import ApplyButtons from '../../../components/ApplyButtons'
import useIsMobile576 from '../../../hooks/useIsMobile576'
import { PATHS } from '../../../utils/utils'
import { BiSolidOffer } from 'react-icons/bi'
import { LuAlignHorizontalDistributeStart } from 'react-icons/lu'
import { MdOutlineSubscriptions } from 'react-icons/md'
import { FaBook, FaFileInvoice } from 'react-icons/fa6'
import SubscriptionChart from '../../../Charts/SubscriptionChart'

const { ipoDefault } = Images

const {
  logo,
  facebook,
  Instagram,
  Telegram,
  Youtube,
  twitter,
  Whatsapp,
  playStore,
  appStore
} = Images

const IPODetailsTab = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { t } = useLocation()

  const [metaData, setMetaData] = useState({
    title: '',
    description: '',
    keyword:
      'IPO Calendar 2025, Upcoming IPOs, Mainboard IPO Calendar, SME IPO Calendar, New IPOs 2025, Apply for IPO, IPO Dates'
  })

  const { ipoDetailData, ipoDetailLoading } = useSelector(
    state => state.ipoDetail
  )

  const { ipoCategory } = useSelector(state => state.ipoData)
  const IpoDetailsPageRedirection = useIpoDetailsPageRedirection()
  const { id, name, tabname } = useParams()
  const isMobile576 = useIsMobile576(576)
  const [activeTab, setActiveTab] = useState(TABKEY?.DETAILS_TAB)
  const [isDocsDropdownOpen, setIsDocsDropdownOpen] = useState(false)
  const [is_loading, setIsLoading] = useState(false)
  const [is_allotnment, setIs_allotnment] = useState(false)

  const [tabDetails, setTabDetails] = useState([
    {
      id: 1,
      key: TABKEY?.DETAILS_TAB,
      name: 'IPO Details',
      content: <IpoDetails location={location} />
    },
    // {
    //   id: 2,
    //   key: TABKEY?.DOC_TAB,
    //   name: 'Docs',
    //   content: <></>
    // },
    ...(ipoDetailData?.ipo_doc_link?.length > 0
      ? [
        {
          id: 2,
          key: TABKEY?.DOC_TAB,
          name: 'Docs',
          content: <></>
        }
      ]
      : []),
    // {
    //   id: 3,
    //   key: TABKEY?.REVIEW_TAB,
    //   name: 'Review',
    //   content: <ReviewDetails location={location} />
    // },
    {
      id: 4,
      key: TABKEY?.SUBSCRIPTION_TAB,
      name: 'Subscription',
      content: (
        <SubscriptionDetails
          location={location}
          id={id}
          is_loading={is_loading}
          setIsLoading={setIsLoading}
        />
      )
    },
    {
      id: 5,
      key: TABKEY?.NEWS_TAB,
      name: 'News',
      content: <NewsDetailsData location={location} />
    },
    {
      id: 6,
      key: TABKEY?.GMP_TAB,
      name: 'GMP',
      content: <GmpDetails />
    },
    {
      id: 7,
      key: TABKEY?.ALLOTNMENT_TAB,
      name: 'Allotment',
      content: <AllotnmentDetails activeTab={activeTab} />
    }
    // {
    //   id: 8,
    //   key: TABKEY?.BASIC_ALLOTNMENT_TAB,
    //   name: 'Basic Allotment',
    //   content: <BasicAllotnmentDetails />
    // },
  ])

  const [tabDetailsMobileView, setTabDetailsMobileView] = useState([
    {
      id: 1,
      key: TABKEY?.DETAILS_TAB,
      name: 'IPO Details',
      content: <>
        <IpoDetails location={location} />
        <GmpDetails />
        <SubscriptionDetails
          location={location}
          id={id}
          is_loading={is_loading}
          setIsLoading={setIsLoading}
        />
        <ReviewDetails location={location} />
      </>
    },

    // {
    //   id: 3,
    //   key: TABKEY?.REVIEW_TAB,
    //   name: 'Review',
    //   content: <ReviewDetails location={location} />
    // },
    // {
    //   id: 4,
    //   key: TABKEY?.SUBSCRIPTION_TAB,
    //   name: 'Subscription',
    //   content: (
    //     <SubscriptionDetails
    //       location={location}
    //       id={id}
    //       is_loading={is_loading}
    //       setIsLoading={setIsLoading}
    //     />
    //   )
    // },
    {
      id: 7,
      key: TABKEY?.ALLOTNMENT_TAB,
      name: 'Allotment',
      content: <AllotnmentDetails activeTab={activeTab} />
    },
    {
      id: 2,
      key: TABKEY?.DOC_TAB,
      name: 'Docs',
      content: <></>
    },
    // ...(ipoDetailData?.ipo_doc_link?.length > 0
    //   ? [
    //     {
    //       id: 2,
    //       key: TABKEY?.DOC_TAB,
    //       name: 'Docs',
    //       content: <></>
    //     }
    //   ]
    //   : []),
    {
      id: 5,
      key: TABKEY?.NEWS_TAB,
      name: 'News',
      content: <NewsDetailsData location={location} />
    },
    // {
    //   id: 6,
    //   key: TABKEY?.GMP_TAB,
    //   name: 'GMP',
    //   content: <GmpDetails />
    // },


    // {
    //   id: 8,
    //   key: TABKEY?.BASIC_ALLOTNMENT_TAB,
    //   name: 'Basic Allotment',
    //   content: <BasicAllotnmentDetails />
    // },
  ])

  const handleTabClick = key => {
    const pathSegments = location.pathname.split('/')
    if (key == TABKEY?.ALLOTNMENT_TAB) {
      setIs_allotnment(true)
    } else {
      setIs_allotnment(true)
    }
    pathSegments[pathSegments.length - 1] = key
    navigate(`${pathSegments.join('/')}`, { replace: true })

    setActiveTab(key)
    setIsDocsDropdownOpen(false)
  }

  const isFirstRun = useRef(true)
  useEffect(() => {
    // if (isFirstRun.current) {
    //   isFirstRun.current = false;
    //   return; // Prevents first duplicate call
    // }

    // const searchParams = new URLSearchParams(location.search);
    // const tabFromUrl = searchParams?.get('ipo-watch'); // Get tab from URL

    // if (!tabFromUrl) {
    //   const searchParams = new URLSearchParams(location.search);
    //   searchParams.set('ipo-watch', location?.state?.tabkey || 'ipo_details' + '-ipo');
    //   navigate(`${location.pathname}?${searchParams.toString()}`, { replace: true });
    // }
    // const extractedTab = tabFromUrl?.split('-')[0];

    if (tabname) {
      // setActiveTab(
      //   location?.state?.tabkey || tabname === TABKEY?.DOC_TAB || location?.state?.tabkey || tabname === TABKEY?.REVIEW_TAB
      //     ? TABKEY?.DETAILS_TAB || tabname === TABKEY?.ALLOTNMENT_TAB
      //     : location?.state?.tabkey || tabname
      // );
      setActiveTab(tabname)
    } else {
      setActiveTab(TABKEY?.DETAILS_TAB)
      const pathSegments = location?.pathname?.split('/')
      pathSegments[pathSegments?.length] = TABKEY?.DETAILS_TAB
      navigate(`${pathSegments.join('/')}`, { replace: true })
    }
  }, [tabname])

  // ------------------------------ Calling Api ------------------------------

  const companyName =
    ipoDetailData?.company_name?.split(' ').slice(0, 2).join(' ') + ' IPO'
  const dispatch = useDispatch()

  const getDetail = async () => {
    try {
      // dispatch(startMasterLoding(true));
      setIsLoading(true)
      if (location?.state?.data?.company_name) {
        dispatch(setIpoDetail(location?.state?.data))
      } else {
        const response = await getIpoDetail(id?.toUpperCase())
        if (response && response.meta && response.meta.status_code === 200) {
          dispatch(setIpoDetail(response.data))
        } else {
          dispatch(setIpoDetail(response.data))
        }
      }
      setIsLoading(false)
    } catch (error) {
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    // if (isFirstRun.current) {
    //   isFirstRun.current = false;
    //   return;
    // }
    getDetail()
  }, [id])

  useEffect(() => {
    const getMetaByTab = () => {
      switch (activeTab) {
        case TABKEY?.DETAILS_TAB:
          return {
            title: `${companyName} : Price, Date, IPO GMP, Details`,
            description: `${companyName}: Grey Market Premium at ₹${`${ipoDetailData?.gmp != null ? ipoDetailData?.gmp : ''
              }`}. Price band ${ipoDetailData?.price_range
              }. Allotment on ${formatDate(
                ipoDetailData?.allotment_date || '-'
              )}. Track live subscription status (QIB/NII/Retail). Should you apply? Expert review inside.`,
            keyword:
              'IPO Details 2025, Aten Papers IPO GMP , IPO grey market premium , IPO allotment date , how to check allotment status , IPO price band , lot size , IPO subscription status , QIB NII Retail demand'
          }
        case TABKEY?.DOC_TAB:
          return {
            title:
              'IPO Documents 2025 | Red Herring Prospectus, DRHP, Company Info',
            description:
              'Access official IPO documents including Red Herring Prospectus, DRHPs, and detailed company filings for 2025.',
            keyword:
              'IPO Documents 2025, RHP, DRHP, IPO Filing, Company Details'
          }
        case TABKEY?.SUBSCRIPTION_TAB:
          return {
            title: `${companyName} Subscription Status Live: QIB/NII/Retail Demand`,
            description: `Track live ${companyName} subscription status with QIB, NII, and Retail demand updates. Check oversubscription trends in real-time.`,
            keyword:
              'IPO subscription, live IPO subscription, IPO demand, QIB NII Retail, oversubscribed IPO'
          }
        case TABKEY?.NEWS_TAB:
          return {
            title: `${companyName} Latest News & Updates`,
            description: `Stay updated with ${companyName} news, including subscription trends, GMP updates, and expert analysis.`,
            keyword:
              'IPO news, IPO updates, Aten Papers IPO latest news, IPO trends'
          }
        case TABKEY?.GMP_TAB:
          return {
            title: `${companyName} GMP Today: Grey Market Premium & Trends`,
            description: `Check today’s ${companyName} Grey Market Premium (GMP) with historical trends. Predict listing gains with unofficial IPO pricing.`,
            keyword:
              'IPO GMP, grey market premium, IPO premium, upcoming IPO GMP, IPO grey market'
          }
        case TABKEY?.ALLOTNMENT_TAB:
          return {
            title: `${companyName} Allotment Status: Fast Check Allotment Here`,
            description: `${companyName} allotment status is out! Check your allotment online via BSE/NSE links and next steps after allotment.`,
            keyword:
              'IPO allotment, IPO allotment status, how to check IPO allotment, BSE IPO allotment'
          }
        default:
          return {
            title: `${companyName} Allotment Status: How to Check Online`,
            description: `${companyName} allotment status is out! Check your allotment online via BSE/NSE links and next steps after allotment.`,
            keyword:
              'IPO allotment, IPO allotment status, how to check IPO allotment, BSE IPO allotment'
          }
      }
    }
    setMetaData(getMetaByTab())
  }, [activeTab, location, ipoDetailData, companyName])

  const linkRef = useRef(null)
  // const handleSelectChange = e => {
  //   const selectedLink = e.target.value
  //   if (selectedLink && linkRef.current) {
  //     linkRef.current.href = selectedLink
  //     // Optional: set target and rel dynamically if needed
  //     linkRef.current.target = '_blank'
  //     linkRef.current.rel = 'noopener noreferrer'

  //     // Trigger the click on hidden anchor to open the link
  //     linkRef.current.click()
  //   }
  // }

  const handleSelectChange = (e) => {
    const url = e.target.value;
    if (url) {
      // Open the URL in a new tab as a direct result of the user gesture
      window.open(url, 'noopener,noreferrer');
    }
  };

  return (
    <>
      <SEOTITLE
        title={metaData?.title}
        description={metaData?.description}
        keyword={metaData?.keyword}
      />
      <div className='container'>
        <BreadCrumb
          title={'IPO Details'}
          header={'IPO Details'}
          subHeaderOnlyView={'IPO Details'}
        />
      </div>

      <div className='details_ipo common_heading_h2 '>IPO Details</div>
      {/* </div> */}
      <div className='container '>
        <div className='border rounded-xl '>
          {is_loading ? (
            <>
              <div className='flex justify-center items-center custom-min-height'>
                <Loader />
              </div>
            </>
          ) : (
            <>
              <div className='details_header'>
                <div className='flex justify-end pt-5 pe-5'>
                  <Labels
                    data={ipoDetailData}
                    classList='badge-container  justify-end items-end flex-column'
                  />
                </div>

                <div className='detials_header detials_header_2 px-2  lg:!pb-8 gap-5 justify-between flex-wrap responsive_table_col_7'>
                  <div className='flex items-center gap-5 w-full lg:w-[72%] flex-wrap'>
                    <div className='w-full md:w-[28%] flex flex-col md:flex-row md:flex-nowrap'>
                      <img
                        src={ipoDetailData?.ipo_image}
                        alt='IPO Image'
                        className=' rounded-lg shadow-md detials_header_img max-w-[200px] mb-5 md:mb-0'
                      />
                      <h2 className='ipoDetailDatacompany_name !ps-0'>
                        {ipoDetailData?.company_name} IPO
                      </h2>
                    </div>

                    <div className='w-full md:w-[68%] flex justify-between items-center flex-wrap'>
                      <div>
                        <div className='common_heading_h2 common_heading_h2_details flex-grow ipoDetailDatacompany_name_desktop'>
                          <h2>{ipoDetailData?.company_name} IPO</h2>
                          <div></div>
                        </div>
                        <div className='flex flex-wrap gap-3  xl:gap-x-5 ipo_detail_header_list'>
                          <div className='w-full md:w-[45%] flex  gap-1'>
                            <h5 className='text-capitalize font-semibold ipo_sub_head min-w-max'>
                              IPO Date :
                            </h5>
                            <label style={{ color: '#7B7B7B' }}>{`${formatDate(
                              ipoDetailData?.start_date
                            )} to ${formatDate(
                              ipoDetailData?.end_date
                            )}`}</label>
                          </div>
                          <div className='w-full md:w-[45%] flex  gap-2'>
                            <h5 className='text-capitalize font-semibold ipo_sub_head min-w-max'>
                              Issue Price :
                            </h5>
                            <label
                              style={{ color: '#7B7B7B' }}
                            >{`${ipoDetailData?.price_range}`}</label>
                          </div>
                          <div className='w-full md:w-[45%] flex  gap-2'>
                            <h5 className='text-capitalize font-semibold ipo_sub_head min-w-max'>
                              Allotment Date :
                            </h5>
                            <label style={{ color: '#7B7B7B' }}>{`${ipoDetailData?.allotment_date != null
                              ? formatDate(ipoDetailData?.allotment_date)
                              : ''
                              }`}</label>
                          </div>
                          <div className='w-full md:w-[45%] flex  gap-2'>
                            <h5 className='text-capitalize font-semibold ipo_sub_head min-w-max'>
                              List Date :
                            </h5>
                            <label style={{ color: '#7B7B7B' }}>{`${ipoDetailData?.listing_date != null
                              ? formatDate(ipoDetailData?.listing_date)
                              : '' || '-'
                              }`}</label>
                          </div>
                          <div className='w-full md:w-[45%] flex  gap-2'>
                            <h5 className='text-capitalize font-bold ipo_sub_head min-w-max'>
                              GMP :
                            </h5>
                            <label
                              style={{ color: '#27ae60', fontWeight: 600 }}
                            >
                              {' '}
                              {ipoDetailData.gmp == null
                                ? '-'
                                : `₹${ipoDetailData.gmp} (${ipoDetailData?.ipo_max_value !== 0 &&
                                (
                                  (ipoDetailData?.gmp /
                                    ipoDetailData?.ipo_max_value) *
                                  100
                                )?.toFixed(2) + '%'
                                })`}
                            </label>
                          </div>
                          <div className='w-full md:w-[45%] flex  gap-2'>
                            <h5 className='text-capitalize font-semibold ipo_sub_head min-w-max'>
                              List Price :
                            </h5>
                            <label style={{ color: '#7B7B7B' }}>{`${ipoDetailData?.listed_price != null
                              ? ipoDetailData?.listed_price
                              : '' || '-'
                              }`}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* flex flex-wrap lg:flex-nowrap lg:flex-col items-start lg:items-center justify-between h-full */}
                  <div className=' w-full lg:w-[25%]  flex flex-wrap lg:flex-col lg:justify-between lg:items-end '>
                    <div></div>
                    <ApplyButtons
                      data={ipoDetailData}
                      ipoCategory={ipoCategory}
                      classList={
                        'broker-actions max-w-[200px] min-w-[200px] !mt-0 me-5 lg:me-0 mb-5 lg:mb-0'
                      }
                      type='inner'
                    />
                    <ul className='social_icons flex flex-wrap gap-4 justify-end pb-2 md:pb-0 pe-2 md:pe-0 '>
                      <li className='social_icon_item_second'>
                        <a
                          href='https://www.facebook.com/share/1P2hsboiYc/'
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          <SEOLINK
                            title='Facebook Link'
                            description='Facebook Link'
                            image={appStore}
                            url='https://www.facebook.com/share/1P2hsboiYc/'
                          />
                          <img
                            src={facebook}
                            alt='Facebook'
                            width={40}
                            height={40}
                          />
                        </a>
                      </li>
                      <li className='social_icon_item_second'>
                        <a
                          href='https://x.com/ipo_trend_'
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          <img
                            src={twitter}
                            alt='Twitter'
                            width={40}
                            height={40}
                          />
                        </a>
                      </li>
                      <li className='social_icon_item_second'>
                        <a
                          href='https://t.me/ipotrend'
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          <img
                            src={Telegram}
                            alt='Telegram'
                            width={40}
                            height={40}
                          />
                        </a>
                      </li>
                      <li className='social_icon_item_second'>
                        <a
                          href='https://www.whatsapp.com/channel/0029Vb1Pg6g6xCSPrDjbw231'
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          <img
                            src={Whatsapp}
                            alt='Whatsapp'
                            width={40}
                            height={40}
                          />
                        </a>
                      </li>
                      <li className='social_icon_item_second'>
                        <a
                          href='https://www.instagram.com/ipo_trend_/'
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          <img
                            src={Instagram}
                            alt='Instagram'
                            width={40}
                            height={40}
                          />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className='tabs-wrapper newTabIpoDetail '>
                <div className='tabs-container'>
                  <div className='tabsss'>
                    {!isMobile576 ? (
                      <div className='tab-menu overflow-x-auto ps-3'>
                        {tabDetails?.length > 0 &&
                          tabDetails?.map(item => (
                            <>
                              {item.key === TABKEY?.DOC_TAB ? (
                                <>
                                  <select
                                    className={`tab-menu-link custom-select p-0 ${activeTab === item?.key ? 'is-active' : ''}`}
                                    defaultValue=''
                                    onChange={handleSelectChange}
                                  >
                                    <option value=''>{item.name}</option>
                                    {ipoDetailData?.ipo_doc_link?.map((docItem, index) =>
                                      docItem?.link ? (
                                        <option key={index} value={docItem.link}>
                                          {docItem.lable}
                                        </option>
                                      ) : null
                                    )}
                                  </select>
                                  {/* <select
                                    className={`tab-menu-link custom-select p-0 ${activeTab === item?.key ? 'is-active' : ''
                                      }`}
                                    defaultValue=''
                                    onChange={handleSelectChange}
                                  >
                                    <option value=''>{item.name}</option>
                                    {ipoDetailData?.ipo_doc_link?.map(
                                      (docItem, index) =>
                                        docItem?.link ? (
                                          <option
                                            key={index}
                                            value={docItem?.link}
                                          >
                                            {docItem.lable}
                                          </option>
                                        ) : null
                                    )}
                                  </select> */}

                                  {/* Hidden anchor tag */}
                                  {/* <a
                                    ref={linkRef}
                                    style={{
                                      position: 'absolute',
                                      left: '-9999px',
                                      width: '1px',
                                      height: '1px',
                                      overflow: 'hidden'
                                    }}
                                    href='/'
                                    target='_blank'
                                    rel='noopener noreferrer'
                                  >
                                    Hidden Link
                                  </a> */}
                                </>
                              ) : (
                                <>
                                  <button
                                    key={item.key}
                                    className={`tab-menu-link ${activeTab === item.key ? 'is-active' : ''
                                      }`}
                                    data-content={item.key}
                                    onClick={() => handleTabClick(item.key)}
                                  >
                                    <span
                                      className='text-nowrap'
                                      data-title={item?.name}
                                    >
                                      {item?.name}
                                    </span>
                                  </button>
                                </>
                              )}
                            </>
                          ))}
                      </div>
                    ) : (
                      <>

                        <div className='tab-menu overflow-x-auto ps-3'>
                          {tabDetailsMobileView?.length > 0 &&
                            tabDetailsMobileView?.map(item => (
                              <>
                                {item.key === TABKEY?.DOC_TAB ? (
                                  <>
                                    <select
                                      onChange={(e) => { handleSelectChange(e) }}
                                      className={`tab-menu-link custom-select p-0 ${activeTab === item?.key ? 'is-active' : ''}`}
                                      defaultValue=''
                                    >
                                      <option value=''>{item.name}</option>
                                      {ipoDetailData?.ipo_doc_link?.map((docItem, index) =>
                                        docItem?.link ? (
                                          <option key={index} value={docItem.link}>
                                            {docItem.lable}
                                          </option>
                                        ) : null
                                      )}
                                    </select>
                                    {/* <ul style={{ listStyle: 'none', padding: 0 }}>
                                      <li style={{ marginBottom: '8px' }}>
                                        <a >
                                          Select
                                        </a>
                                      </li>
                                      {ipoDetailData?.ipo_doc_link?.map((docItem, index) =>
                                        docItem?.link ? (<>

                                          <li key={index} style={{ marginBottom: '8px' }}>
                                            <a href={docItem.link} target="_blank" rel="noopener noreferrer">
                                              {docItem.lable}
                                            </a>
                                          </li>
                                        </>) : null
                                      )}
                                    </ul> */}
                                    {/* <select
                                      className={`tab-menu-link custom-select p-0 ${activeTab === item?.key ? 'is-active' : ''
                                        }`}
                                      defaultValue=''
                                      onChange={handleSelectChange}
                                    >
                                      <option value=''>{item.name}</option>
                                      {ipoDetailData?.ipo_doc_link?.map(
                                        (docItem, index) =>
                                          docItem?.link ? (
                                            <option
                                              key={index}
                                              value={docItem?.link}
                                            >
                                              {docItem.lable}
                                            </option>
                                          ) : null
                                      )}
                                    </select> */}

                                    {/* Hidden anchor tag */}
                                    {/* <a
                                      ref={linkRef}
                                      style={{
                                        position: 'absolute',
                                        left: '-9999px',
                                        width: '1px',
                                        height: '1px',
                                        overflow: 'hidden'
                                      }}
                                      href='/'
                                      target='_blank'
                                      rel='noopener noreferrer'
                                    >
                                      Hidden Link
                                    </a> */}
                                  </>
                                ) : (
                                  <>
                                    <button
                                      key={item.key}
                                      className={`tab-menu-link ${activeTab === item.key ? 'is-active' : ''
                                        }`}
                                      data-content={item.key}
                                      onClick={() => handleTabClick(item.key)}
                                    >
                                      <span
                                        className='text-nowrap'
                                        data-title={item?.name}
                                      >
                                        {item?.name}
                                      </span>
                                    </button>
                                  </>
                                )}
                              </>
                            ))}
                        </div>

                        <div className='grid grid-cols-3 gap-4 w-full px-3 pt-5'>
                          <div className='col-span-1 shadow-[0_3px_8px_rgba(0,0,0,0.24)] py-2 px-2 rounded-lg flex items-strech justify-center min-h-[120px]'>
                            <a
                              href='#offers'
                              className='flex flex-col justify-center h-full'
                            >
                              <div className='min-w-[60px] min-h-[60px] flex items-center justify-center'>
                                {' '}
                                <BiSolidOffer className='mx-auto block text-[#043873] text-[40px]' />
                              </div>
                              <h4 className='text-[#043873] text-medium text-center text-[12px] leading-[16px] min-h-[32px] max-h-[32px] flex items-center justify-center'>
                                Ipo Details
                              </h4>
                            </a>
                          </div>
                          <div className='col-span-1 shadow-[0_3px_8px_rgba(0,0,0,0.24)] py-2 px-2 rounded-lg flex items-strech justify-center min-h-[120px]'>
                            <a
                              href='#offers'
                              className='flex flex-col justify-center h-full'
                            >
                              <div className='max-h-[100px] max-w-[100px]'>
                                <div className='min-w-[60px] min-h-[60px] flex items-center justify-center'>
                                  {' '}
                                  <SubscriptionChart />
                                </div>
                              </div>
                              <h4 className='text-[#043873] text-medium text-center text-[12px] leading-[16px] min-h-[32px] max-h-[32px] flex items-center justify-center'>
                                Subscription
                              </h4>
                            </a>
                          </div>
                          <div className='col-span-1 shadow-[0_3px_8px_rgba(0,0,0,0.24)] py-2 px-2 rounded-lg flex items-strech justify-center min-h-[120px]'>
                            <a
                              href='#offers'
                              className='flex flex-col justify-center h-full'
                            >
                              <div className='min-w-[60px] min-h-[60px] flex items-center justify-center'>
                                {' '}
                                <LuAlignHorizontalDistributeStart className='mx-auto block text-[#043873] text-[30px]' />
                              </div>
                              <h4 className='text-[#043873] text-medium text-center text-[12px] leading-[16px] min-h-[32px] max-h-[32px] flex items-center justify-center'>
                                Lot Distribution
                              </h4>
                            </a>
                          </div>
                          <div className='col-span-1 shadow-[0_3px_8px_rgba(0,0,0,0.24)] py-2 px-2 rounded-lg flex items-strech justify-center min-h-[120px]'>
                            <a
                              href='#offers'
                              className='flex flex-col justify-center h-full'
                            >
                              <div className='min-w-[60px] min-h-[60px] flex items-center justify-center'>
                                {' '}
                                <FaFileInvoice className='mx-auto block text-[#043873] text-[30px]' />
                              </div>
                              <h4 className='text-[#043873] text-medium text-center text-[12px] leading-[16px] min-h-[32px] max-h-[32px] flex items-center justify-center'>
                                Reservation
                              </h4>
                            </a>
                          </div>
                          <div className='col-span-1 shadow-[0_3px_8px_rgba(0,0,0,0.24)] py-2 px-2 rounded-lg flex items-strech justify-center min-h-[120px]'>
                            <a
                              href='#offers'
                              className='flex flex-col justify-center h-full'
                            >
                              <div className='min-w-[60px] min-h-[60px] flex items-center justify-center'>
                                {' '}
                                <FaBook className='mx-auto block text-[#043873] text-[30px]' />
                              </div>
                              <h4 className='text-[#043873] text-medium text-center text-[12px] leading-[16px] min-h-[32px] max-h-[32px] flex items-center justify-center'>
                                Company Financials
                              </h4>
                            </a>
                          </div>
                          <div className='col-span-1 shadow-[0_3px_8px_rgba(0,0,0,0.24)] py-2 px-2 rounded-lg flex items-strech justify-center min-h-[120px] bg-[#e9f7ef]'>
                            <a
                              href='#offers'
                              className='flex flex-col justify-center h-full items-center'
                            >
                              <div className='min-w-[60px] min-h-[60px] max-w-[60px] max-h-[60px] flex items-center justify-center p-2'>
                                <h4
                                  className=' text-medium text-center text-[16px] leading-[16px]  min-h-[32px]  mx-auto h-full w-full  flex items-center justify-center text-[#27AE60]'
                                >
                                  ₹
                                  {`${ipoDetailData?.gmp != null
                                    ? ipoDetailData?.gmp
                                    : ''
                                    }`}
                                </h4>
                              </div>
                              <h4 className='text-medium text-center text-[12px] leading-[16px] min-h-[32px] max-h-[32px] flex items-center justify-center text-[#27AE60]'>
                                Premium (ELP)
                              </h4>
                            </a>
                          </div>
                        </div>
                      </>
                    )}
                    {
                      isMobile576 ? (<>
                        <div className="tab-bar mt-4">
                          {tabDetailsMobileView?.map((item) => (
                            <div
                              key={item.key}
                              className={`tab-bar-content ${activeTab === item.key ? "is-active" : "hidden"}`}
                            >
                              {item.content}
                            </div>
                          ))}
                        </div>
                      </>) : (<>
                        <div className="tab-bar mt-4">
                          {tabDetails?.map((item) => (
                            <div
                              key={item.key}
                              className={`tab-bar-content ${activeTab === item.key ? "is-active" : "hidden"}`}
                            >
                              {item.content}
                            </div>
                          ))}
                        </div>
                      </>)
                    }
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <Footer />
    </>
  )
}
export default IPODetailsTab
